<template>
  <div @click="go()" class="menuIcon" :class="name" :id="'menu-' + name">
    <slot></slot>
  </div>
</template>
<script>
import reportDataService from 'reportData.service'
const config = {
  registeredPrompt: {
    name: '挂号须知',
    url: 'registeredPrompt'
  },
  register: {
    name: '挂号',
    url: 'departDoctor'
  },
  hosinfo: {
    name: '医院介绍',
    url: 'hosinfo'
  },
  pay: {
    name: '门诊缴费',
    url: 'clinicUnpayList'
  },
  myregister: {
    name: '我的挂号',
    url: 'myregister'
  },
  myreport: {
    name: '我的报告',
    url: 'myreport',
  },
  mypay: {
    name: '我的缴费',
    url: 'mypay',
  },
  bedsinfo: {
    name: '床位查询',
    url: 'bedsinfo',
  },
  doctinfolist: {
    name: '医生介绍',
    url: 'doctinfolist',
  },
  healthRecord: {
    name: '健康证申领',
    url: 'https://mp.weixin.qq.com/s/jBSQd1QfI9FfH_F94VDlig',
  },
  outregister: {
    name: '市外挂号',
    url: 'https://jksc.scwjxx.cn/',
  },
  inpatientprepay: {
    name: '住院预缴金',
    url: 'InpatientRecharge',
  },
  outMap: {
    name: '来院导航',
    url: 'outMap',
  },
  inMap: {
    name: '院内导航',
    url: 'inMap',
  },
  waitDoctor: {
    name: '排队候诊',
    url: 'waitDoctor',
  },
  MyPrescription: {
    name: '电子处方',
    url: 'MyPrescription',
  },
  InpatientRegister: {
    name: '线上住院登记',
    url: 'InpatientRegister',
  },
  residentHealthRecord: {
    name: '居民健康档案',
    url: 'residentHealthRecord',
  },
  familyDoctor: {
    name: '家庭医生签约',
    url: 'https://www.99kst.com/usergroup?verType=jkpzjyt',
  },
  heathBasicInformation: {
    name: '健康档案信息维护',
    url: 'maintaing',
  },
  selfHealthAssessment: {
    name: '自我健康状况评估',
    url: 'https://cs.atag.bshcn.com.cn/intelligenceserver/view/index',
   // url: 'https://h5.witspring.com/xtdyrmyxy/search/symptom/moreProbality?symptomWord=%E5%92%B3%E5%97%BD',
  },
  emergencyCall: {
    name: '急救呼叫',
    url: 'http://pzwjw-imts.hngwmt.com/jkda/BsoftWeChatPZ/index/#/emergency_contact_index',
  },
  heathGuide: {
    name: '健康指导',
    url: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1MjY2ODMyNQ==#wechat_redirect',
  },
  healthAdvice: {
    name: '健康咨询',
    url: 'maintaing',
  },
  HospitalCostList: {
    name: '住院费用查询',
    url: 'HospitalCostList',
  },
  littleAssistant: {
    name: 'AI健康小助手',
    url: 'littleAssistant',
  },
  internetHospital: {
    name: '互联网医院',
    url: 'internetHospital',
  },
  SurveyList: {
    name: '满意度评价',
    url: 'SurveyList',
  }
}
export default {
  props: {
    name: String
  },
  mounted () {
    this.icon = config[this.name]
  },
  data: function () {
    return {
      icon: '',
      channel: localStorage.channel,
      text: '',
    };
  },
  methods: {
    go () {
      if (this.name === "healthAdvice") {
        reportDataService.reportData({
          serviceId: this.constant.SERVICE_ID.HEALTH_CONSULTATION,
          certificateId: '',
          certificateType: '',
        })
        this.$emit("showHealthAdvice")
        return
      }
      if (this.name === "healthRecord") {
        window.location.href = this.icon.url
        return
      }
      if (this.name === "littleAssistant") {
        // window.location.href = this.icon.url
        return
      }
      if (this.name === "internetHospital") {
        window.location.href = this.icon.url
        return
      }
      if (this.name === "heathGuide") {
        reportDataService.reportData({
          serviceId: this.constant.SERVICE_ID.HEALTH_LIFE_GUIDANCE,
          certificateId: '',
          certificateType: '',
        })
        window.location.href = this.icon.url
        return
      }
      if (this.name === "familyDoctor") {
        // 数据上报
        reportDataService.reportData({
          serviceId: this.constant.SERVICE_ID.FAMILY_DOCTOR_SIGNING,
          certificateId: '',
          certificateType: '',
        })
        window.location.href = this.icon.url
        return
      }
      if (this.name === "selfHealthAssessment") {
        // 数据上报
        reportDataService.reportData({
          serviceId: this.constant.SERVICE_ID.SELF_HEALTH_ASSESSMENT,
          certificateId: '',
          certificateType: '',
        })
        window.location.href = this.icon.url
        return
      }
      if (this.name === "emergencyCall") {
        reportDataService.reportData({
          serviceId: this.constant.SERVICE_ID.EMERGENCY_CALL_SERVICE,
          certificateId: '',
          certificateType: '',
        })
        window.location.href = this.icon.url
        return
      }
      // 每次进入预约挂号或医院介绍或医生介绍之前必须选医院
      if ((this.name === "HospitalCostList") || (this.name === "register") || (this.name === 'hosinfo') || (this.name === "doctinfolist") || (this.name === "bedsinfo") || (this.name === 'inpatientprepay') || (sessionStorage.getItem('areaType') != '1' && this.name === 'pay') || (sessionStorage.getItem('areaType') != '1' && this.name === 'mypay') || (sessionStorage.getItem('areaType') != '1' && this.name === 'myreport') || (this.name === 'waitDoctor') || (this.name === "outMap") || (this.name === "inMap") || (this.name === 'MyPrescription') || (this.name === 'InpatientRegister')) {  //市内挂号
        //默认进入科室选择
        window.localStorage.tabId = "0";
        this.$store.commit('updateParam', {
          namespace: 'menu',
          url: this.icon.url
        });
        sessionStorage.setItem('areaType', '1')
        sessionStorage.setItem('busiType', '1')
        this.$router.push("HospitalSelect");
      } else if (this.name === "outregister") {   //市外挂号
        // //默认进入科室选择
        // window.localStorage.tabId = "0";
        // this.$store.commit('updateParam', {
        //   namespace: 'menu',
        //   url: this.icon.url
        // });
        // sessionStorage.setItem('areaType', '2')
        // sessionStorage.setItem('busiType', '1')
        // this.$router.push("HospitalSelect");
        window.location.href = this.icon.url
        return
      } else if (this.name === 'myregister') {
        //查询所有的医院
        //默认进入科室选择
        window.localStorage.tabId = "0";
        this.$store.commit('updateParam', {
          namespace: 'menu',
          url: this.icon.url
        });
        if (this.channel === 'TFY') {
          sessionStorage.setItem('areaType', '1')
        } else {
          sessionStorage.setItem('areaType', '0')
        }
        sessionStorage.setItem('busiType', '2')
        this.$router.push("HospitalSelect");
      } else {
        this.$router.push(this.icon.url)
      }
    },
  }
}
</script>
<style lang="scss">
//图标和文字水平排列
@import "../../static/sass/_variable.scss";
.row-menu {
  padding: 0 15px;
  @include display-flex();
  margin-bottom: 8px;
}

.menu-h {
  text-align: center;
  @include flex(1);
  position: relative;
  padding: 17px 5px;
  font-size: 16px;
  color: #fff;
  border-radius: 5px;
  &:first-child {
    margin-right: 10px;
  }
  .menu-icon {
    display: inline-block;
    vertical-align: middle;
    width: 48px;
    height: 48px;
    background: no-repeat right;
    background-size: contain;
  }
  .menu-text {
    display: inline-block;
    vertical-align: middle;
  }
}

//菜单图标
.menu-h {
  //我的缴费
  &.register {
    @include shandow(#4ccab1);
    background-color: #55e2c5;
    .menu-icon {
      background-image: url(../../static/img/home-register.png);
    }
  }
  /*医院介绍*/
  &.hosinfo {
    @include shandow(#65a9e1);
    background-color: #70bcfb;
    .menu-icon {
      background-image: url(../../static/img/home-hosinfo.png);
    }
  }
  /*门诊缴费*/
  &.pay {
    @include shandow(#d57565);
    background-color: #ed8271;
    .menu-icon {
      background-image: url(../../static/img/home-pay.png);
    }
  }
  /*预约挂号*/
  &.myregister {
    @include shandow(#e4b54e);
    background-color: #fec957;
    .menu-icon {
      background-image: url(../../static/img/my-register.png);
    }
  }
  //我的报告
  &.myreport {
    @include shandow(#a477dc);
    background-color: #b784f5;
    .menu-icon {
      background-image: url(../../static/img/my-report.png);
    }
  }
  &.mypay {
    @include shandow(#6480cd);
    background-color: #6f8fe4;
    .menu-icon {
      background-image: url(../../static/img/my-pay.png);
    }
  }
  &.bedsinfo {
    @include shandow(#ae805e);
    background-color: #c28f69;
    .menu-icon {
      background-image: url(../../static/img/home-beds.png);
    }
  }
  &.doctinfolist {
    @include shandow(#40bf4b);
    background-color: #47d554;
    .menu-icon {
      background-image: url(../../static/img/home-doctinfo.png);
    }
  }
}
</style>



// WEBPACK FOOTER //
// Menu.vue?63852c74